import { Tooltip } from 'antd';
import { connect } from 'react-redux';

import { getOpenedTaskId } from '../../../../../redux/general/selectors';
import TaskSubtaskSection from '../TaskSubtaskSection';

const AddButtonLabel = ({ title, onClick, disabled, showIcon = true, isGuest }) => {
  if (isGuest) {
    return null;
  }

  return (
    <Tooltip title={!disabled && title}>
      <div
        className="flex items-center gap-1.5 px-2 py-0.5 rounded-lg cursor-pointer transition-colors"
        style={{
          background: 'rgba(99,102,241,0.07)',
          color: showIcon ? 'rgba(99,102,241,0.75)' : 'rgba(99,102,241,0.6)',
          border: '1px solid rgba(99,102,241,0.2)',
          fontSize: 12,
          fontWeight: 500,
        }}
        onMouseEnter={e => { e.currentTarget.style.background = 'rgba(99,102,241,0.13)'; e.currentTarget.style.color = '#4f46e5'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'rgba(99,102,241,0.07)'; e.currentTarget.style.color = showIcon ? 'rgba(99,102,241,0.75)' : 'rgba(99,102,241,0.6)'; }}
        onClick={onClick}
      >
        {showIcon && (
          <svg width="11" height="11" viewBox="0 0 16 16" fill="currentColor">
            <path d="M8 2a1 1 0 0 1 1 1v4h4a1 1 0 1 1 0 2H9v4a1 1 0 1 1-2 0V9H3a1 1 0 1 1 0-2h4V3a1 1 0 0 1 1-1z"/>
          </svg>
        )}
        <span>{title}</span>
      </div>
    </Tooltip>
  );
};

const TaskDetailsSubtasks = ({ taskId }) => {
  return (
    <TaskSubtaskSection
      taskId={taskId}
      AddButtonLabel={AddButtonLabel}
    />
  );
}

const mapStateToProps = (state) => ({
  taskId: getOpenedTaskId(state),
});

export default connect(mapStateToProps)(TaskDetailsSubtasks);
